// ============================================
// Float16 Training Instance Details
// ============================================

export interface Float16TrainingJob {
  name: string;
  baseModel: string;
  method: 'full' | 'lora' | 'qlora';
  status: 'training' | 'completed' | 'failed' | 'queued';
  progress: number;
  config: {
    learningRate: number;
    batchSize: number;
    epochs: number;
    loraRank?: number;
    loraAlpha?: number;
  };
  metrics: {
    loss: number;
    evalLoss?: number;
    step: number;
    totalSteps: number;
  };
}

export interface Float16TrainingDetails {
  frameworkVersion: string;
  status: 'active' | 'idle';
  jobs: Float16TrainingJob[];
  datasetPath: string;
  checkpointsPath: string;
  wandbProject?: string;
  notebookUrl: string;
}

export const mockFloat16TrainingDetails = (taskId: string): Float16TrainingDetails => ({
  frameworkVersion: '1.2.0',
  status: 'active',
  jobs: [
    {
      name: 'llama3-8b-customer-support',
      baseModel: 'meta-llama/Llama-3.1-8B',
      method: 'lora',
      status: 'training',
      progress: 73,
      config: {
        learningRate: 2e-4,
        batchSize: 4,
        epochs: 3,
        loraRank: 16,
        loraAlpha: 32,
      },
      metrics: {
        loss: 0.892,
        evalLoss: 0.945,
        step: 2190,
        totalSteps: 3000,
      },
    },
    {
      name: 'mistral-7b-code-assistant',
      baseModel: 'mistralai/Mistral-7B-v0.3',
      method: 'qlora',
      status: 'completed',
      progress: 100,
      config: {
        learningRate: 1e-4,
        batchSize: 2,
        epochs: 2,
        loraRank: 32,
        loraAlpha: 64,
      },
      metrics: {
        loss: 0.534,
        evalLoss: 0.612,
        step: 5000,
        totalSteps: 5000,
      },
    },
  ],
  datasetPath: '/workspace/training_data',
  checkpointsPath: '/workspace/checkpoints',
  wandbProject: 'float16-finetune',
  notebookUrl: `http://localhost:8888/lab?token=float16-${taskId.slice(0, 8)}`,
});
